

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.2Sl0UX5M.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DuUomSZU.js"];
export const stylesheets = ["_app/immutable/assets/2.SH5I4EuT.css"];
export const fonts = [];
